export function isValidCPF(input: string): boolean {
  const cpf = input.replace(/\D/g, '');

  if (cpf.length !== 11) return false;

  // Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  // Validação do primeiro dígito verificador
  const firstDigit = checkDigit(cpf, 9);
  if (Number(cpf[9]) !== firstDigit) return false;

  // Validação do segundo dígito verificador
  const secondDigit = checkDigit(cpf, 10);
  if (Number(cpf[10]) !== secondDigit) return false;

  return true;
}

function checkDigit(cpf: string, length: number): number {
  const sum = cpf
    .split('')
    .slice(0, length)
    .reduce(
      (accumulator, digit, i) => accumulator + Number(digit) * (length + 1 - i),
      0,
    );

  const remainder = (sum * 10) % 11;
  return remainder === 10 ? 0 : remainder;
}
